export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "close_sidebar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fermer la barre latérale"])},
        "open_sidebar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ouvrir la barre latérale"])},
        "open_user_menu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ouvrir le menu utilisateur"])}
      },
      "en": {
        "close_sidebar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close sidebar"])},
        "open_sidebar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Open sidebar"])},
        "open_user_menu": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Open user menu"])}
      }
    }
  })
}
